@if (!error()) {
	<sl-dialog
		class="upload-modal"
		[title]="config()?.title"
		[data-testid]="testIds.Dialog">
		<ng-container content>
			<div class="upload-modal__content">
				<mat-icon
					class="file-icon"
					svgIcon="csv"
					aria-label="CSV file"></mat-icon>
				<div class="sl-flexbox sl-flexbox-column sl-flexbox-basis-100 sl-flexbox-gap-5">
					<div class="sl-flexbox sl-flexbox-align-center sl-typography-body-medium">
						<div
							class="sl-flexbox-basis-100"
							[data-testid]="testIds.FileInfo">
							{{ config()?.file?.name }} | {{ config()?.file?.size / 1024 | number: "1.1-1" }}KB
						</div>
						@if (!uploadFinished()) {
							<sl-text-button
								label="Cancel"
								(onClick)="onCancel()"></sl-text-button>
						} @else {
							<sl-button
								label="View"
								(onClick)="onView()"></sl-button>
						}
					</div>
					@if (!uploadFinished()) {
						<mat-progress-bar mode="indeterminate"></mat-progress-bar>
					} @else {
						<mat-progress-bar
							mode="determinate"
							value="100"></mat-progress-bar>
					}
				</div>
			</div>
			@if (uploadFinished()) {
				<div
					class="description sl-typography-body-medium"
					[data-testid]="testIds.SuccessMessage">
					File uploaded successfully.
					<br />
					{{ uploadSuccessMessage() }}
				</div>
			}
		</ng-container>
		<ng-container actions>
			@if (uploadFinished()) {
				<sl-text-button
					label="Close"
					[mat-dialog-close]="true"
					[disabled]="isLoading()"></sl-text-button>
			}
		</ng-container>
	</sl-dialog>
} @else {
	<sl-dialog
		class="upload-modal"
		[title]="error()"
		[data-testid]="testIds.ErrorDialog">
		<ng-container content>
			<div
				class="upload-modal__error sl-typography-body-medium"
				[innerHtml]="errorMessage()"
				[data-testid]="testIds.ErrorMessage"></div>
		</ng-container>
		<ng-container actions>
			<sl-button
				label="Got it"
				[mat-dialog-close]="true"
				[disabled]="isLoading()"></sl-button>
		</ng-container>
	</sl-dialog>
}
